import { AutomationsPresentationV1 } from 'Automations/automationEditor'

export const CONTRACT_EXTRACTION_BASE: AutomationsPresentationV1 = {
  version: 1,
  nodes: [
    {
      id: '9d6e1d6f-fee2-4104-b886-381d004e2632',
      type: 'START_CONTRACT_UPLOADED',
      position: { x: -382, y: -21 },
      data: { name: '', trigger: 'CONTRACT_UPLOADED' }
    },
    {
      id: '32017178-9a09-4c02-9927-eb8e8f5333e8',
      type: 'REVIEW_CONTRACT',
      position: { x: 80, y: -21 },
      data: { name: '', reviewType: 'CONTRACT', approverUserIds: [] }
    },
    {
      id: 'e7441546-db39-449d-9fc3-702bffc22a51',
      type: 'ACTION_CREATE_SCHEDULE',
      position: { x: 262, y: -21 },
      data: { name: '', actionType: 'CREATE_SCHEDULE' }
    },
    {
      id: '5838ce64-222e-4066-a502-06bfdd3f1a63',
      type: 'ACTION_CONTRACT_EXTRACTION',
      position: { x: -151, y: -21 },
      data: { name: '', actionType: 'CONTRACT_EXTRACTION' }
    },
    {
      id: 'd506fbd4-f39f-4b54-a025-05ba6d3a9ff5',
      type: 'END',
      position: { x: 485, y: -21 },
      data: { name: '' }
    }
  ],
  edges: [
    {
      source: '9d6e1d6f-fee2-4104-b886-381d004e2632',
      sourceHandle: '9d6e1d6f-fee2-4104-b886-381d004e2632:source',
      target: '5838ce64-222e-4066-a502-06bfdd3f1a63',
      targetHandle: '5838ce64-222e-4066-a502-06bfdd3f1a63:target',
      id: 'xy-edge__9d6e1d6f-fee2-4104-b886-381d004e26329d6e1d6f-fee2-4104-b886-381d004e2632:source-5838ce64-222e-4066-a502-06bfdd3f1a635838ce64-222e-4066-a502-06bfdd3f1a63:target'
    },
    {
      source: '5838ce64-222e-4066-a502-06bfdd3f1a63',
      sourceHandle: '5838ce64-222e-4066-a502-06bfdd3f1a63:source',
      target: '32017178-9a09-4c02-9927-eb8e8f5333e8',
      targetHandle: '32017178-9a09-4c02-9927-eb8e8f5333e8:target',
      id: 'xy-edge__5838ce64-222e-4066-a502-06bfdd3f1a635838ce64-222e-4066-a502-06bfdd3f1a63:source-32017178-9a09-4c02-9927-eb8e8f5333e832017178-9a09-4c02-9927-eb8e8f5333e8:target'
    },
    {
      source: '32017178-9a09-4c02-9927-eb8e8f5333e8',
      sourceHandle: '32017178-9a09-4c02-9927-eb8e8f5333e8:source',
      target: 'e7441546-db39-449d-9fc3-702bffc22a51',
      targetHandle: 'e7441546-db39-449d-9fc3-702bffc22a51:target',
      id: 'xy-edge__32017178-9a09-4c02-9927-eb8e8f5333e832017178-9a09-4c02-9927-eb8e8f5333e8:source-e7441546-db39-449d-9fc3-702bffc22a51e7441546-db39-449d-9fc3-702bffc22a51:target'
    },
    {
      source: 'e7441546-db39-449d-9fc3-702bffc22a51',
      sourceHandle: 'e7441546-db39-449d-9fc3-702bffc22a51:source',
      target: 'd506fbd4-f39f-4b54-a025-05ba6d3a9ff5',
      targetHandle: 'd506fbd4-f39f-4b54-a025-05ba6d3a9ff5:target',
      id: 'xy-edge__e7441546-db39-449d-9fc3-702bffc22a51e7441546-db39-449d-9fc3-702bffc22a51:source-d506fbd4-f39f-4b54-a025-05ba6d3a9ff5d506fbd4-f39f-4b54-a025-05ba6d3a9ff5:target'
    }
  ]
}
